import { Box, Button, Container, TextField, Typography } from "@mui/material";
import { HeaderBar } from "../../common/Header";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../redux/CAS/authConfig";
import { inUser, outUser } from "../../redux/slices/auth.slice";
import ConsultasService from "../../pages/Ranking/services/ConsultasService"; 
import Swal from 'sweetalert2'; 

export const Login: React.FC<{}> = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [correo, setCorreo] = useState<string>("");
    
    const isEmailValid = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isButtonDisabled = !isEmailValid(correo);

    const { isAuth } = useAppSelector((state) => state.authReducer);
    const { instance } = useMsal();
    const disableMsal = process.env.REACT_APP_DISABLE_MSAL === 'true';

    useEffect(() => {
        if (isAuth) {
            navigate("/");
        }
    }, [isAuth, navigate]);

    const handleAccesoDenegado = () => {
        Swal.fire({
            icon: 'error',
            title: 'Acceso Denegado',
            text: 'No tienes los permisos necesarios para ingresar al sistema de Ranking.',
            confirmButtonColor: '#243165'
        }).then(() => {
            dispatch(outUser());
        });
    };

    const handleLogin = async (e?: React.FormEvent) => {
        if (e) e.preventDefault();

        if (disableMsal) {
            try {
                const usuario = correo.split('@')[0];
                const data = await ConsultasService.Account("30", usuario);

                let jwtExpiration = "";
                if (data?.token) {
                    try {
                        const base64Url = data.token.split('.')[1];
                        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                        const payload = JSON.parse(window.atob(base64));
                        if (payload.exp) jwtExpiration = payload.exp.toString();
                    } catch (error) {
                        console.error("Error al decodificar el JWT:", error);
                    }
                }

                const roles = data?.user?.roles || []; 
                const rolEncontrado = roles.find((rol:any) => rol.nombreRol === "ADMIN RANKING INVESTIGACIÓN") || 
                                      roles.find((rol:any) => rol.nombreRol === "LECTOR RANKING INVESTIGACIÓN");

                if (rolEncontrado) {
                    dispatch(inUser({
                        isAuth: true,
                        token: data.token,
                        userData: {
                            usuario: usuario,
                            token: data.token,
                            expiration: jwtExpiration || "9999-12-31" 
                        },
                        rol: rolEncontrado.nombreRol,
                        isLoading: false,
                    }));
                } else {
                    handleAccesoDenegado();
                }
            } catch (error) {
                console.error("Error consultando el servicio en entorno de pruebas:", error);
                Swal.fire({ icon: 'error', title: 'Error', text: 'Error al conectar con el servidor.'});
            }
        } else {
            // FLUJO REAL CON MSAL (Redirect)
            // Solo redirigimos. La validación sucederá en HeaderWithMsal al volver.
            instance.loginRedirect({
                ...loginRequest,
                loginHint: correo // Pasamos el correo para que no lo vuelva a escribir
            }).catch((error) => {
                console.error("Error al intentar iniciar sesión con Microsoft:", error);
            });
        }
    };

    return (
        <>
            <HeaderBar />
            <Box sx={{ textAlign: "center", marginTop: "40px" }}>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: '#243165' }}>
                    SISTEMA DE RANKING
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    Ingresa con tus credenciales institucionales para continuar.
                </Typography>
            </Box>
            <Container maxWidth="sm" sx={{ borderRadius: "5px", padding: "25px", textAlign: "center", marginTop: "10px" }}>
                <Box component="form" onSubmit={handleLogin}>
                    <TextField
                        fullWidth
                        id="correo"
                        name="correo"
                        label="Correo"
                        type="email"
                        error={correo !== "" && !isEmailValid(correo)}
                        helperText={correo !== "" && !isEmailValid(correo) ? "Ingresa un correo válido" : ""}
                        value={correo}
                        onChange={(e) => setCorreo(e.target.value)}
                        sx={{ marginBottom: '20px', width: '80%', '& input:-webkit-autofill': { WebkitBoxShadow: '0 0 0px 1000px #fff inset' } }}
                    />
                    <Button
                        sx={{ backgroundColor: '#243165', color: "white !important", width: "50%", borderRadius: "25px", '&:hover': { backgroundColor: '#1a244d' } }}
                        variant="contained"
                        type="submit"
                        disabled={isButtonDisabled}
                    >
                        ENTRAR
                    </Button>
                </Box>
            </Container>
        </>
    );
};